<template>
  <!-- eslint-disable max-len -->
  <div class="KeyBoard">
    <div class="close-area" @click="hideKeyBoard">
      <img src="../../src/assets/key-board-close.png" alt="" />
    </div>
    <div class="KeyBoard-content">
      <div class="number-container">
        <div class="KeyBoard-row">
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 1 }"
            @touchstart.stop.prevent="activeEl(1)"
            @touchend="handleEnter('1')"
          >
            1
          </span>
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 2 }"
            @touchstart.stop.prevent="activeEl(2)"
            @touchend="handleEnter('2')"
          >
            2
          </span>
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 3 }"
            @touchstart.stop.prevent="activeEl(3)"
            @touchend="handleEnter('3')"
          >
            3
          </span>
        </div>
        <div class="KeyBoard-row">
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 4 }"
            @touchstart.stop.prevent="activeEl(4)"
            @touchend="handleEnter('4')"
          >
            4
          </span>
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 5 }"
            @touchstart.stop.prevent="activeEl(5)"
            @touchend="handleEnter('5')"
          >
            5
          </span>
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 6 }"
            @touchstart.stop.prevent="activeEl(6)"
            @touchend="handleEnter('6')"
          >
            6
          </span>
        </div>
        <div class="KeyBoard-row">
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 7 }"
            @touchstart.stop.prevent="activeEl(7)"
            @touchend="handleEnter('7')"
          >
            7
          </span>
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 8 }"
            @touchstart.stop.prevent="activeEl(8)"
            @touchend="handleEnter('8')"
          >
            8
          </span>
          <span
            class="KeyBoard-cell KeyBoard-num"
            :class="{ active: index === 9 }"
            @touchstart.stop.prevent="activeEl(9)"
            @touchend="handleEnter('9')"
          >
            9
          </span>
        </div>
        <div class="KeyBoard-row">
          <span
            class="KeyBoard-num KeyBoard-zero"
            :class="{ active: index === 0 }"
            @touchstart.stop.prevent="activeEl(0)"
            @touchend="handleEnter('0')"
          >
            0
          </span>
          <span
            v-if="hasDotBoard"
            class="KeyBoard-num KeyBoard-dot"
            :class="{ active: index === 11 && extraValue !== '' }"
            @touchstart.stop.prevent="activeEl(11)"
            @touchend="() => extraValue && handleEnter(extraValue)"
          >
            .
          </span>
        </div>
      </div>
      <div class="operator-container">
        <span
          class="KeyBoard-del"
          :class="{ active: index === 10 }"
          @touchstart.stop.prevent="activeEl(10)"
          @touchend="handleDelete"
        >
          <img src="../../src/assets/keyboard-del.png" alt="delete" />
        </span>
        <span class="KeyBoard-btn" :class="disabled ? 'disabled' : ''" @touchstart.stop.prevent="handleConfirm">{{
          confirmWord
        }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AmountKeyBoard',
  props: {
    extraKey: {
      type: String,
      default: '',
    },
    extraValue: {
      type: String,
      default: '',
    },
    confirmWord: {
      type: String,
      default: '',
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    hasDotBoard: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      index: -1,
    };
  },
  methods: {
    activeEl(i: any) {
      this.index = i;
    },
    handleConfirm() {
      this.closeKeyBoard();
    },
    closeKeyBoard() {
      this.$emit('closeKeyBoard');
    },
    handleEnter(value: any) {
      this.index = -1;
      this.$emit('keyBoardEnter', value ? value.toString() : '');
    },
    handleDelete() {
      this.index = -1;
      this.$emit('keyBoardDelete');
    },
    hideKeyBoard() {
      this.$emit('hideKeyBoard');
    },
  },
});
</script>

<style lang="less" scoped>
@keyframes slidein {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
.KeyBoard {
  background: #eeeeee;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  .close-area {
    height: 0.64rem;
    display: flex;
    justify-content: center;
    border-top: 1px solid #e1e1e1;
    img {
      margin-top: 0.2rem;
      height: 0.24rem;
      width: 0.24rem;
    }
  }
  // 遮罩
  &-mask {
    width: 100%;
    height: 100%;
    bottom: 0;
    position: absolute;
  }
  // 键盘
  &-content {
    animation: 0.7s ease-out 1 cubic-bezier(0.1, 0.3, 0.25, 1);
    display: flex;
    background: #eeeeee;
    z-index: 999;
    justify-content: space-around;
    padding: 0.04rem 0.08rem 0 0.08rem;
    padding-bottom: 0.68rem;
  }
  // 行
  &-row {
    display: flex;
  }
  // 键
  &-cell {
    font-size: 0.34rem;
    line-height: 1.18rem;
    text-align: center;
    flex: 1;
    margin: 0.06rem;
    padding-top: 0.02rem;
    &.active {
      background: #e5e5e5;
    }
  }
  // 数字
  &-num {
    border-radius: 0.16rem;
    background: white;
    font-family: 'MTNewDigitalDisplay-Medium', monospace;
    font-size: 0.4rem;
    color: #191919;
    font-weight: 500;
  }
  // 删除
  &-del {
    height: 1.2rem;
    line-height: 1.2rem;
    background: #fff;
    position: relative;
    z-index: 10;
    border-radius: 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.06rem;
    img {
      width: 0.38rem;
      height: 0.38rem;
      transform: scale(1.2);
    }
    &.active {
      background: #e5e5e5;
    }
  }
  // 按钮
  &-btn {
    border-radius: 0.16rem;
    background-image: linear-gradient(135deg, #ffe74d 0%, #ffdd19 100%);
    font-weight: bold;
    position: relative;
    z-index: 10;
    font-size: 0.3rem;
    color: #000000;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.06rem;
    &.disabled {
      opacity: 0.5;
    }
  }
  &-zero {
    margin: 0.06rem;
    flex: 2.1;
    line-height: 1.2rem;
    text-align: center;
    font-family: 'MTNewDigitalDisplay-Medium', monospace;
    font-size: 0.4rem;
    color: #191919;
    font-weight: 500;
    &.active {
      background: #e5e5e5;
    }
  }
  &-dot {
    margin: 0.06rem;
    flex: 1;
    line-height: 1rem;
    text-align: center;
    font-family: 'MTNewDigitalDisplay-Medium', monospace;
    font-size: 0.4rem;
    color: #191919;
    font-weight: 500;
    &.active {
      background: #e5e5e5;
    }
    img {
      width: 0.15rem;
      height: 0.2rem;
    }
    .icon-error {
      font-size: 0.2rem;
      color: #000000;
    }
  }
  .number-container {
    width: 75%;
  }
  .operator-container {
    width: 25%;
    display: flex;
    flex-direction: column;
  }
}
</style>
